import React from 'react';
import styles from './consultancyStep.module.css';

interface StepLabelProps {
  children: React.ReactNode;
}

const StepLabel: React.FC<StepLabelProps> = ({ children }) => (
  <p className={styles.stepLabel}>{children}</p>
);

export default StepLabel;
